import styles from "./Home.module.css";
import clsx from "clsx";
import Grid from "../common/Grid";
import ProjectCard from "./ProjectCard";
import AboutLinks from "./AboutLinks";

const Home = () => {
  return (
    <div>
      <Grid className={styles.header}>
        <AboutLinks />
        <p className={styles.about}>
          <b>I’m Anya</b>, a Senior Software Engineer. I’m product-minded
          by default. The way I think about software has been shaped by
          the teams I’ve worked on, the tools I’ve loved using, and a few
          people I admire: <b>John Carmack</b> for depth and grit,{" "}
          <b>Valentina D’Efilippo</b> (a former teacher) for the conviction
          that complex and beautiful aren’t a trade-off, and{" "}
          <b>Judy Faulkner</b> for leading on merit, the kind of team I want
          to build with.
        </p>
      </Grid>
      <div className={clsx(styles.projectContainer)}>
        <ProjectCard
          image="/images/9fin-cover.svg"
          altText=""
          link="/build"
          name="Building, not Coding"
          type="Case study"
          tech="Product Engineering"
          dates="Sep 24 - Present"
          company="Misc"
          hoverColor="#D4E0FC"
          isExternal={false}
        />
        <ProjectCard
          image="/images/redjack-cover.png"
          altText=""
          link="/redjack"
          name="Redjack"
          type="Case study"
          tech="Front-end development, UI/UX Design"
          dates="Apr 26"
          company="Personal"
          hoverColor="#FFD3D3"
          isExternal={false}
          comingSoon
        />
        <ProjectCard
          image="/images/echo-cover.png"
          altText="echo-studio "
          link="/echo"
          name="Echo studio"
          type="Case study"
          tech="Front-end development, UI/UX Design"
          dates="Sep 23 - Jun 24"
          company="Pollinate"
          hoverColor="#D2D4D6"
          isExternal={false}
        />
        <ProjectCard
          image="/images/framer-cover.png"
          altText=""
          link="https://medium.com/@anya./react-framer-sequences-397db9375fb4"
          name="Framer motion"
          type="Publication"
          tech="Front-end development"
          dates="May 24"
          company="Medium"
          hoverColor="#FBD4D6"
          isExternal={true}
        />
        <ProjectCard
          image="/images/loupe-cover.png"
          altText=""
          link="/loupe"
          name="Loupe"
          type="Case study"
          tech="Front-end development, UI/UX Design"
          dates="Sep 22 - Jun 23"
          company="Loupe"
          hoverColor="#FCF2D4"
          isExternal={false}
        />
        <ProjectCard
          image="/images/syncing-cover.png"
          altText=""
          link="https://medium.com/@anya./syncing-software-design-development-how-to-push-code-changes-from-figma-21babf7e6ac3"
          name="Syncing Design & Development"
          type="Publication"
          tech="Front-end development"
          dates="May 23"
          company="Medium"
          hoverColor="#E3E4EC"
          isExternal={true}
        />

        <ProjectCard
          image="/images/analogue-cover.png"
          altText=""
          link="/analogue"
          name="Analogue"
          type="Case study"
          tech="Front-end development, UI/UX Design"
          dates="Sep 23 - Jun 24"
          company="Pollinate, iwocaPay"
          hoverColor="#D5DAF6"
          isExternal={false}
        />
        <ProjectCard
          image="/images/multi-cover.png"
          altText=""
          link="/multi-transactions"
          name="Multi-transactions"
          type="Case study"
          tech="UI/UX Design"
          dates="Jan 22 - Jun 22"
          company="iwocaPay"
          hoverColor="#D2E8D6"
          isExternal={false}
        />
        <ProjectCard
          image="/images/access-cover.png"
          altText=""
          link="/access"
          name="Instant access"
          type="Case study"
          tech="UI/UX Design"
          dates="Sep 21 - Dec 21"
          company="iwocaPay"
          hoverColor="#F6D5E8"
          isExternal={false}
        />
        <ProjectCard
          image="/images/format-cover.png"
          altText=""
          link="/format"
          name="Format"
          type="Case study"
          tech="Front-end development, UI/UX Design"
          dates="Jan 25 - Mar 25"
          company="Format"
          hoverColor="#D4F0E8"
          isExternal={false}
          comingSoon
        />
        <ProjectCard
          image="/images/hacking-cover.png"
          altText=""
          link="https://anyad.substack.com/p/learning-low-level-buffer-overflow"
          name="Learning Low-level: Buffer Overflow"
          type="Publication"
          tech="Security research"
          dates="Jan 26"
          company="ENTRY(_start)"
          hoverColor="#D8F0C8"
          isExternal={true}
        />
      </div>
      <Grid className={styles.footer}>
        <p className={styles.copyright}>©2024</p>
      </Grid>
    </div>
  );
};

export default Home;
